// export.ts — CSV export of the catalog (all local; nothing leaves the device).

import type { Item } from "./store";
import { titleCase } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Name, Category, Season, Occasion, Location, Quantity, Last used, Notes. */
export function itemsCsv(items: Item[]): string {
  return csv(
    ["Name", "Category", "Season", "Occasion", "Location", "Quantity", "Last used", "Notes"],
    items.map((i) => [
      i.name,
      titleCase(i.category),
      titleCase(i.season),
      i.occasion ?? "",
      i.location ?? "",
      i.quantity,
      i.last_used_on ?? "Never",
      i.notes ?? "",
    ]),
  );
}

export function buildExport(items: Item[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: itemsCsv(items), filename: `stash-catalog-${stamp}.csv` };
}
